const COLORS = {
  primary: '#1e232f',
  background: '#FAFAFA',
  border: '#C8C8C8',
  cardBorder: 'rgba(0,0,0,0.05)',
};

export default COLORS;
